import { useState } from 'react';
import '../styles/HomePage.css';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  // Contact form state removed as it's not currently used

  const navigate = useNavigate();

  const handleNewsletterSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Add newsletter subscription logic here
      await new Promise(resolve => setTimeout(resolve, 1000));
      setEmail('');
      alert('Thank you for subscribing!');
    } catch (error) {
      alert('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // For navigation
  const handleNavigate = path => {
    navigate(path);
  };

  return (
    <div className='homepage'>
      <main className='main-content'>
        {/* Hero Section */}
        <section className='hero-section' aria-label='Welcome'>
          <div className='hero-overlay'></div>
          <div className='container hero-content'>
            <div className='hero-text-container'>
              <h1 className='hero-title'>
                <span className='brand-name'>AmFashion</span>
                <span className='brand-tagline'>Where Style Meets Elegance</span>
              </h1>
              <p className='hero-subtitle'>
                Discover luxury fashion that defines your unique style. From timeless classics to
                contemporary trends, find pieces that make every occasion extraordinary.
              </p>
              <div className='hero-actions'>
                <button
                  onClick={() => handleNavigate('/shop')}
                  className='shop-now-btn primary'
                  aria-label='Shop Now'
                >
                  Explore Collection
                </button>
                <button
                  onClick={() => handleNavigate('/customize-outfit')}
                  className='shop-now-btn secondary'
                  aria-label='Create Custom Outfit'
                >
                  Style Studio
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Coming Soon Section */}
        <section className='coming-soon' aria-label='Coming Soon'>
          <div className='container'>
            <h2>Coming Soon</h2>
            <div className='coming-soon-cards'>
              {['Tops', 'Bottoms', 'Outfits'].map(item => (
                <div className='coming-soon-card' key={item}>
                  <button
                    onClick={() => handleNavigate('/coming-soon')}
                    className='card-content'
                    aria-label={`Coming soon: ${item}`}
                  >
                    <h3>{item}</h3>
                    <p>
                      {item === 'Tops'
                        ? 'New styles and trends coming soon.'
                        : item === 'Bottoms'
                          ? 'Exclusive designs to elevate your look.'
                          : 'Stylish outfits for every occasion.'}
                    </p>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className='section-divider'></div>

        {/* Stay Updated Section */}
        <section className='stay-updated-section' aria-label='Newsletter'>
          <div className='container'>
            <h2>Stay Updated</h2>
            <p>
              Sign up for our newsletter and be the first to know about new collections and offers.
            </p>
            <form className='newsletter-form' onSubmit={handleNewsletterSubmit}>
              <input
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder='Enter your email'
                required
                aria-label='Email for newsletter'
              />
              <button type='submit' disabled={isLoading}>
                {isLoading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
          </div>
        </section>

        {/* Contact Us Section */}
        <section className='contact-us-section'>
          <div className='container'>
            <h2>Contact Us</h2>
            <p>
              We&apos;d love to hear from you! Reach out to us with your queries, feedback, or
              concerns.
            </p>
            <form className='contact-form'>
              <input type='text' placeholder='Your Name' required />
              <input type='email' placeholder='Your Email' required />
              <textarea placeholder='Your Message' rows='5' required></textarea>
              <button type='submit'>Send Message</button>
            </form>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className='footer'>
        <div className='container'>
          <p>&copy; {new Date().getFullYear()} Amiras Fashion. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
